import type { VoiceNoteResult } from './types'
import { USE_MOCK_API } from './httpClient'
import { uploadVoiceMock } from './voice.mock'
import { uploadVoiceHttp } from './voice.http'

export type { VoiceNoteResult }

export function uploadVoiceNote(
  tripId: string,
  blob: Blob,
  pointId: string | null,
  clientId?: string,
): Promise<VoiceNoteResult> {
  return USE_MOCK_API
    ? uploadVoiceMock(tripId, blob, pointId, clientId)
    : uploadVoiceHttp(tripId, blob, pointId, clientId)
}
